import Paper from '@mui/material/Paper';
import { TableContainer, Table, TableHead, TableBody, TableRow, Box } from '@mui/material';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import { styled } from '@mui/material/styles';
import Announce from '@/types/Announce.type';

type Props = {
  announces: Array<Announce>;
};

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  padding: '6px 10px',
  fontSize: 14,
  borderLeft: '1px solid #E2E7EA',
  borderBottom: '1px solid #E2E7EA',
}));

const StyledTableCellHead = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: '#ced7dc',
    color: '#3e3a3a',
    fontSize: 15,
    fontWeight: 'bold',
    borderLeft: '1px solid #E2E7EA',
    borderBottom: '2px solid #E2E7EA',
    padding: '3px 10px',
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(even)': {
    backgroundColor: '#F3F5F7',
  },
}));
const Announcement: React.FC<Props> = ({ announces }) => {
  return (
    <TableContainer component={Paper}>
      <Table size="small">
        <TableHead>
          <TableRow style={{ backgroundColor: '#1976D2' }}>
            <StyledTableCellHead align="left" style={{ width: '30%' }}>
              タイトル
            </StyledTableCellHead>
            <StyledTableCellHead align="left">内容</StyledTableCellHead>
          </TableRow>
        </TableHead>
        <TableBody>
          {announces.map((announceRow) => (
            <StyledTableRow key={announceRow.id}>
              <StyledTableCell align="left" style={{ width: '30%', borderLeft: '1px solid #eceff1' }}>
                {announceRow.title}
              </StyledTableCell>
              <StyledTableCell align="left" style={{ borderLeft: '1px solid #eceff1' }}>
                <Box style={{ whiteSpace: 'pre-wrap' }}>{announceRow.content}</Box>
              </StyledTableCell>
            </StyledTableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
export default Announcement;
